import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { useTranslation } from 'react-i18next'

const DisclaimerBody = ({ onAcknowledge }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text size='small'>{t('disclaimer.title').toUpperCase()}</Text>
      <Heading level={3}>{t('disclaimer.subtitle')}</Heading>
      <Text>{t('disclaimer.body')}</Text>
      <Box paddingTop={4} />
      <Flex alignX='end'>
        <Button type='primary' onClick={onAcknowledge}>
          {t('disclaimer.acknowledge')}
        </Button>
      </Flex>
    </>
  )
}

export default DisclaimerBody
